import { BingMapMarker } from '../../bing-maps/bing-map-marker';

export class Library {
  id: string;
  name: string;
  address: string;
  online = false;
  lat: number;
  lon: number;
  url?: string;
  items?: any[];

  constructor(attr: { id: string, name: string, address?: string, online?: boolean, lat?: number, lon?: number, url?: string, items?: any[] }) {
    this.id = attr.id;
    this.name = attr.name;
    this.address = attr.address;
    this.online = attr.online;
    this.url = attr.url;
    this.lat = attr.lat;
    this.lon = attr.lon;
    this.items = attr.items;
    if(attr.items && attr.items.length > 0){
      let object = attr.items.find(i => i.url !== undefined);
      if(object){
        this.url = object.url;
      }
    }
  }

  public toBingMapMarker(index: string): BingMapMarker {
    return new BingMapMarker(
      this.lat,
      this.lon,
      this.online,
      index,
      this.name,
      '<span style="display: table-row">' + this.address + '</span></br>',
      this.url);
  }

  public toBindMapMarkerSimple() {
    return new BingMapMarker(this.lat, this.lon, this.online);
  }


}
